export const stepIconFontSize = 18;
